<template>
	<div class="vue-wrapper">
	<lane-closure-request-quick-nav v-if="!$store.state.isMobile" v-model="laneClosureRequest" selected="contraventions"></lane-closure-request-quick-nav>
	<lane-closure-request-quick-nav-mobile v-if="$store.state.isMobile" v-model="laneClosureRequest" :contravention="contravention" selected="contraventions"></lane-closure-request-quick-nav-mobile>
	<b-container class="laneclosure-view-container report-contravention-container" v-if="laneClosureRequest != null && contravention != null && loaded">
		<b-form onsubmit="return false;">
			<b-row v-if="$store.state.isMobile">
				<b-col class="pt-0 lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" xl="9">
					<div class="d-flex lcr-page-title">
						<div>
							<h1>Edit Violation #{{contravention.id}}</h1>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row :class="$store.state.isMobile ? 'lcr-detail-mobile-wrapper' : ''">
				<b-col v-if="!$store.state.isMobile" class="lcr-quick-nav-summary" sm="12" lg="9">
					<b-row v-if="laneClosureRequest.isEmergency.value == 1">
						<b-col>
							<h1>Edit Violation #{{contravention.id}}</h1>
						</b-col>
					</b-row>
					<b-row v-if="laneClosureRequest.isEmergency.value == 0">
						<b-col>
							<h1>Edit Violation #{{contravention.id}}</h1>
						</b-col>
					</b-row>
					<b-row v-if="laneClosureRequest.requesterProjectName ">
						<b-col class="pt-1">
							<h2>Project: {{laneClosureRequest.requesterProjectName}}</h2>
						</b-col>
					</b-row>

					<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
					<!-- <div class="d-flex lcr-main-summary">
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Info</div>
							<div class="lcr-summary__value" v-show="laneClosureRequest.trafficManagementRef.value">TM: {{laneClosureRequest.trafficManagementRef.value}}</div>
							<div class="lcr-summary__value">LCR: {{laneClosureRequest.id}}</div>
						</div>
						<div class="lcr-main-summary__info flex-grow-1">
							<div class="lcr-summary__label">Affected Streets</div>
							<div class="lcr-summary__value">{{directionOfTravel}}</div>
							<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
							<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
						</div>
						<div class="lcr-main-summary__info pt-4">
							<div class="show-on-map-wrapper">
								<a class="show-on-map text-left" @click="showOnMap">
									<span class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
										<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
									</span>
								</a>
							</div>
						</div>
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Primary Reason for Closure</div>
							<div class="lcr-summary__value">{{natureOfWork}}</div>
						</div>
						<div class="lcr-main-summary__info ">
							<div class="lcr-summary__label">Date(s)</div>
							<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('MM/DD/YYYY')}} - {{moment(laneClosureRequest.toDate.value).format('MM/DD/YYYY')}}</div>
							<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('H:mm')}} - {{moment(laneClosureRequest.toDate.value).format('H:mm')}}</div>
						</div>
						<div class="lcr-main-summary__info" v-if="laneClosureRequest.completeTypeId.value != null">
							<div class="lcr-summary__label">Complete Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.completeTypeId.value)}}</div>
						</div>
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Approval Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.approvalStatusId.value)}}</div>
							<div class="lcr-summary__label">Record Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.recordStatusId.value)}}</div>
						</div>
					</div> -->
				</b-col>
				<b-col v-if="$store.state.isMobile" class="lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" lg="9">
					<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="7">
					<b-row v-show="canReportContravention" class="pt-3">
						<b-col sm="12" class="mb-3">
						<div v-if="$store.state.isMobile" class="mt-3">Click the <strong>Communication</strong> button at the top to read and leave messages regarding this violation.</div>
						</b-col>
						<b-col sm="12" class="mb-3">
							<div v-if="contravention.createdBy" class="lcr-summary__label">Created By</div>
							<div v-if="contravention.createdBy" class="contact">
								<div class="contact__name">{{contravention.createdBy.firstName}} {{contravention.createdBy.lastName}}</div>
								<div class="contact__organization">{{contravention.createdBy.organizationName}}</div>
								<div class="contact__phone">{{contravention.createdBy.phone}}</div>
							</div>
							<div class="lcr-summary__label">Enforcement Officer</div>
							<div v-if="contravention.officer" class="contact">
								<div class="contact__name">{{contravention.officer.firstName}} {{contravention.officer.lastName}}</div>
								<div class="contact__organization">{{contravention.officer.organizationName}}</div>
								<div class="contact__phone">{{contravention.officer.phone}}</div>
							</div>
							<autocomplete data-position="above" :search="onOfficerSearch" @submit="onOfficerSelect" placeholder="Start typing to select Enforcement Officer" aria-label="Start typing to select Enforcement Officer" ref="searchOfficer" auto-select>
								<template v-slot:result=" {result, props } ">
									<li v-bind="props" class="autocomplete-result primary-contact-result">
										<div class="contact-name">{{result.firstName}} {{result.lastName}}</div>
										<div class="contact-organization">{{result.organizationName}}</div>
										<div class="contact-phone">{{result.phone}}</div>
									</li>
								</template>
							</autocomplete>
						</b-col>
						<b-col sm="12" class="mb-3">
							<div class="lcr-summary__label">Violation Type</div>
							<div class="lcr-summary__value">
								<b-form-select v-model="contravention.typeId.value" :options="Contravention.getContraventionTypeIdOptions" @input="contravention.typeId.resetStatus()" :state="contravention.typeId.status" value-field="id" text-field="name"></b-form-select>
							</div>
						</b-col>
						<b-col sm="12" class="mb-3">
							<div class="lcr-summary__label">Details</div>
							<wysiwyg v-model="contravention.comments.value" />
						</b-col>


						<b-col sm="12">
							<div class="lcr-summary__label">Attachments</div>
							<div class="attachment__uploader">
							<file-pond credits="false" name="attachment" ref="pond" label-idle="<span class='filepond--label-action'>Select files</span>" v-bind:allow-multiple="true" 
								accepted-file-types="image/jpeg, image/png, application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-ms-excel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint"
								v-on:init="handleFilePondInit" v-on:addfile="handleFilePondAddFile" v-on:processfilestart="handleFilePondProcessFileStart" v-on:processfiles="handleFilePondProcessAllFiles" v-on:processfileabort="handleFilePondProcessAbort" v-on:error="handleFilePondProcessError"  v-on:processfile="handleFilePondProcessFile">
							</file-pond>
							</div>
						</b-col>
						<b-col sm="12">
							<attachments-list lg="4"   :sourceId="contravention.id" a:sourceTable="'contravention_attachment'" v-model="contravention" :downloadToken="downloadToken" :downloadTokenExpires="downloadTokenExpires" ref="refAttachments"></attachments-list>
						</b-col>
						<b-col sm="12" class="text-right mt-lg-3 mb-3">
							<div class="vue-form-wizard-wrapper">
			 				<div class="vue-form-wizard md">
							<div class="wizard-card-footer clearfix">
								<div class="wizard-footer-left">
									<button type="button" class="btn btn-light" @click="onBackToContraventions">Cancel</button>
								</div>
								<div class="wizard-footer-right">
									<b-button :disabled="isButtonDisabled" variant="primary" @click="onSaveContravention">Save Violation <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button>
								</div>
							</div>
							</div>
							</div>

						</b-col>
					</b-row>

					<b-row v-show="!canReportContravention" class="pt-3">
						<b-col sm="12" class="mb-3">
							<div class="lcr-summary__label">Enforcement Officer</div>
							<div v-if="contravention.officer" class="contact">
								<div class="contact__name">{{contravention.officer.firstName}} {{contravention.officer.lastName}}</div>
								<div class="contact__organization">{{contravention.officer.organizationName}}</div>
								<div class="contact__phone">{{contravention.officer.phone}}</div>
							</div>
						</b-col>
						<b-col sm="12" class="mb-3">
							<div class="lcr-summary__label">Violation Type</div>
							<div class="lcr-summary__value">{{Contravention.getContraventionTypeIdText(contravention.typeId.value)}}</div>
						</b-col>
						<b-col sm="12" class="mb-3">
							<div class="lcr-summary__label">Details</div>
							<div class="lcr-summary__value" v-html="contravention.comments.value"></div>
						</b-col>
						<b-col sm="12">
							<div class="lcr-summary__label">Attachments</div>
							<attachments-list lg="4"  :sourceId="contravention.id" a:sourceTable="'contravention_attachment'" v-model="contravention" :downloadToken="downloadToken" :downloadTokenExpires="downloadTokenExpires" ref="refAttachments"></attachments-list>
						</b-col>
					</b-row>



				</b-col>
			<b-col class="lcr-summary__right-column hide-mobile" lg="5">
				<div class="lcr-summary__section-label">Communication</div>

				<h2>Messages</h2>
				<message-chat :busy="sendingMessage" v-model="contravention.message" :laneClosureRequestId="laneClosureRequest.id" sourceTable="contravention_message" v-bind:key="'edit-contravention-message'+contravention.id"></message-chat>
			</b-col>
			</b-row>
			<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
				<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
				<ul>
					<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'req'+requiredField">{{$t(requiredField)}}</li>
				</ul>
				<template slot="footer">
					<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
				</template>
			</b-modal>
			<!-- leaving page -->
			<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
				<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
				<template v-slot:modal-footer="{ ok }">
					<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
					<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
					<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
				</template>
			</b-modal>
		</b-form>

	</b-container>
</div>
</template>
<script>
// import CloneDeep from 'lodash.clonedeep';
import LaneClosureRequest from '../../models/LaneClosureRequest';
import LaneClosureRequestBlock from '../../models/LaneClosureRequestBlock';
import Contravention from '../../models/Contravention';
import Attachment from '../../models/Attachment';

import LaneClosureViewInfo from '../../components/LaneClosureViewInfo.vue';

// import Datepicker from 'vuejs-datepicker';
import BootstrapField from '../../utility/BootstrapField';
import Autocomplete from '@trevoreyre/autocomplete-vue'

import Format from '../../utility/Format';

import ErrorHandler from '../../utility/ErrorHandler';
import { gmapApi } from 'gmap-vue'
import KMLHelper from '../../utility/KMLHelper';

import MessageChat from '../../components/MessageChat';
import LaneClosureRequestMessage from '../../models/LaneClosureRequestMessage';
import LaneClosureRequestQuickNav from '../../components/LaneClosureRequestQuickNav.vue';
import LaneClosureRequestQuickNavMobile from '../../components/LaneClosureRequestQuickNavMobile.vue';

import AttachmentsList from '../../components/AttachmentsList.vue';



// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';

import store from '../../store';

import Vue from 'vue'
export default {
	name: 'EditContravention',

	components: {
		MessageChat,
		Autocomplete,
		LaneClosureViewInfo,
		LaneClosureRequestQuickNav,
		LaneClosureRequestQuickNavMobile,
		'attachments-list': AttachmentsList,
		FilePond: vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileMetadata, FilePondPluginFileRename)
	},
	props: ['id', 'contraventionId'],
	data() {
		return {
			LaneClosureRequest,
			Contravention,
			sendingMessage: false,
			downloadToken:null,
			downloadTokenExpires:null,
			googleSearch: null,
			laneClosureRequest: null,
			submitted: null,
			savedChanges: false,
			saving: false,
			showCancelModal: false,
			showCompletedModal: false,
			contravention: null,
			organizationUserOptions: [],
			organizationOptions: [],
			onSubmitPromiseDeferred: {
				resolve: null,
				reject: null
			},
			showUnsavedChangesModal: false,
			lineIndexError: null,
			isButtonDisabled: false,
			saveState: null,
			modalRequiredFieldList: [],
			newProject: {
				name: new BootstrapField({
					value: null
				}),
				isActive: new BootstrapField({
					value: true
				}),
				comments: new BootstrapField({
					value: null
				})
			},

			selectRequester: new BootstrapField({
				value: null,
			}),
			selectAlternateContact: new BootstrapField({
				value: null,
			}),

			selectRestrictionReporter: new BootstrapField({
				value: null,
			}),

			selectAltRestrictionReporter: new BootstrapField({
				value: null,
			}),



			showRequiredFieldModal: false,
			requesterProjectIdOptions: [],
			requesterInfo: null,
			requesterProjectInfo: null, // have to save the project information, in case they change the user, the project will be gone.
			altRequesterInfo: [],
			closureReporterInfo: null,
			altClosureReporterInfo: [],
			restrictionReporterInfo: null,
			altRestrictionReporterInfo: [],

			refSearchRequester: null,
			mapTracks: [],
			mapAffectedGroup: null,
			show: true,
			projectLabel: "Requester's Project",
			agreeResponsibilities: new BootstrapField({
				value: null,
				required: true,
				invalidMessage: 'You have to agree the conditions and responsibilities before submitting',
			}),
			enablePerIntersectionRestriction: new BootstrapField({
				value: null,
				invalidMessage: 'Please indicate if you wish to adjust per intersection restriction',
			}),

			enableDczRequired: new BootstrapField({
				value: null
			}),
			showSpeedReduction: new BootstrapField({
				value: null
			}),
			// For less than two hour modal
			showLessThanTwoHourModal: false,
			lessThanTwoHourModalp1: '',
			lessThanTwoHourModalp2: '',
			showNewProjectModal: false
		}
	},
	mounted() {
		this.setEventBusOn();
		// TODO: verify their permissions for this lane closure request.
		// this.getPermission();
		this.Load();
		this.$nextTick(() => {})
	},
	computed: {
		getAttachmentApi() {
			return `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`
		},
		canCompleteRequest() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.recordStatusId.value != 7) {
					return true;
				}
			}
			return false;
		},
		canReportContravention() {
			return this.$store.getters.userCanReportContravention();
		},


		googleMap: gmapApi,
		disableStartDate() {
			return {
				to: new Date()
			};
		},
		getEditRequestLink() {
			return "/lane-closure-request/" + this.laneClosureRequest.id + "/edit";
		},
		disableEndDate() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.fromDate && this.laneClosureRequest.fromDate.value) {
					return { to: new Date(this.laneClosureRequest.fromDate.value) };
				}
			}
			return {};
		},
		friendlyFromToDate() {
			// let diff = Format.diffYMDHMS(this.laneClosureRequest.fromDate.value, this.laneClosureRequest.toDate.value);
			return null;
		},
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				return Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},
		getPeakIdText() {
			if (this.laneClosureRequest.peakId.value) {
				return Format.searchById(this.laneClosureRequest.peakId.value, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},

		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		},
		transitFieldsState() {
			if (this.laneClosureRequest.transitAffected.status == null &&
				this.laneClosureRequest.transitOther.status == null &&
				this.laneClosureRequest.transitStopNumbers.status == null
			) {
				return null;
			}

			return false;
		},
		projectTimeDuration() {
			/*
			if (this.laneClosureRequest.fromDate.valid && this.laneClosureRequest.toDate.valid) {
				if (this.laneClosureRequest.fromDate.valid && this.laneClosureRequest.toTime.valid) {
					let startTime = this.moment(this.laneClosureRequest.fromDate.value);
					startTime.minutes(Number(this.laneClosureRequest.fromDate.value.mm));
					let startPmAddTime = (this.laneClosureRequest.fromDate.value.a == 'pm' && this.laneClosureRequest.fromDate.value.h != '12' ? 12 : 0);
					startPmAddTime = this.laneClosureRequest.fromDate.value.a == 'am' && this.laneClosureRequest.fromDate.value.h == '12' ? -12 : startPmAddTime;
					startTime.hours(Number(this.laneClosureRequest.fromTime.value.h) + startPmAddTime);

					let endTime = this.moment(this.laneClosureRequest.toDate.value);
					endTime.minutes(Number(this.laneClosureRequest.toTime.value.mm));
					let endPmAddTime = (this.laneClosureRequest.toTime.value.a == 'pm' && this.laneClosureRequest.toTime.value.h != '12' ? 12 : 0);
					startPmAddTime = this.laneClosureRequest.toTime.value.a == 'am' && this.laneClosureRequest.toTime.value.h == '12' ? -12 : startPmAddTime;
					endTime.hours(Number(this.laneClosureRequest.toTime.value.h) + endPmAddTime);

					// return Math.abs(this.moment.duration(startTime.diff(endTime)).asHours());
					return this.moment.duration(endTime.diff(startTime)).asHours();
				}
			}
			*/
			return null;
		},
	},

	watch: {
		'$route.params': function() {
			// for changing route within the same component
			this.Load(this.$route.params.id);
		},
	},

	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
		modalOnCancel() {
			this.showUnsavedChangesModal = false;
		},
		setEventBusOff() {
			this.$bus.$off('view-lcr:map:block-click', this.onMapBlockClick);
			this.$bus.$off('view-lcr:map:block-edit', this.onMapBlockEdit);
			this.$bus.$off('message:newMessage', this.sendNewMessage);
			this.$bus.$off("attachment:updateComment", this.SaveAttachmentComment);
			this.$bus.$off("attachment:autoSave", this.SaveAttachmentComment);
			this.$bus.$off("attachment:delete", this.deleteAttachment);

		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('view-lcr:map:block-click', this.onMapBlockClick);
			this.$bus.$on('view-lcr:map:block-edit', this.onMapBlockEdit);
			this.$bus.$on('message:newMessage', this.sendNewMessage);
			this.$bus.$on("attachment:updateComment", this.SaveAttachmentComment);
			this.$bus.$on("attachment:autoSave", this.SaveAttachmentComment);
			this.$bus.$on("attachment:delete", this.deleteAttachment);

		},
		SaveAttachmentComment(obj) {
			if (obj.comments != null && obj.comments != "" && obj.attachmentId != null) {
				let postData = {
					comments: obj.comments
				}
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/comment?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: postData
				}).then(resp => {

				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		deleteAttachment(obj) {
			//edit request tab DCZ, Transit, Parking
			this.isButtonDisabled = true;
			if (obj.userId != null && obj.attachmentId != null) {
				Vue.prototype.$http({
					method: 'delete',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/delete?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
				}).then(resp => {
					if(resp.status === 200){
						// Find the index of the attachment with the given id
						const index = this.contravention.attachment.findIndex((attachment) => attachment.id === obj.attachmentId);
						// If found, remove it from the array TO hide the deleted attachment tile from view
						if (index !== -1) {
							this.contravention.attachment.splice(index, 1);
						}
					}
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response) {
							this.contravention.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						}
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		handleFilePondAddFile(e, file, m) {},
		handleFilePondInit: function() {
			this.$refs.pond._pond.setOptions({
				server: {
					header: {
						Authorization: "Bearer " + this.$store.state.token
					},
					process: {
						method: 'POST',
						url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						withCredentials: true
					},

					//  url: this.$store.state.apiUrl},
					// timeout: 7000,
					//  process: {
					//      method: 'POST',
					//      url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					//      withCredentials: true,
					//      headers: this.$axios.defaults.headers.common
					//  },
					//  revert: (uniqueFileId, load, error) => {
					//      // remove from toUpload
					//      var index = this.userFiles.toUpload.indexOf(uniqueFileId);
					//      if (index > -1) {
					//          this.userFiles.toUpload.splice(index, 1);
					//      }
					//      // Should remove the earlier created temp file here
					//      this.$axios.post(`${this.$store.state.apiUrl}/attachment/revert?r=${Math.round(Math.random() * Math.pow(10, 6))}`, {
					//          _method: 'DELETE',
					//          uniqueID: uniqueFileId,
					//          resource: this.options.resource
					//      });

					//      // error();
					//      load();
					//  },
					//  load: {
					//      method: 'GET',
					//      url: '/img/'
					//  }
				}
			});
			this.$refs.pond._pond.setOptions({
				fileMetadataObject: {
					comments: null
				},
				allowImagePreview: false,
				allowRevert: false,
				allowReorder: false,
				allowReplace: false,
				server: {
					url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					headers: {
						Authorization: "Bearer " + this.$store.state.token
					}
				}
			});
		},

		handleFilePondProcessFileStart(e,p) {
			this.isButtonDisabled = true;
		},
		handleFilePondProcessAllFiles(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessError(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessAbort(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessFile(e, p) {
			if (p.error) {
				// there was a problem!
			} else {
				let attachmentData = JSON.parse(p.serverId);
				this.downloadToken = attachmentData.downloadToken;
				this.downloadTokenExpires = attachmentData.downloadTokenExpires;
				this.contravention.attachment.unshift(new Attachment(attachmentData.attachment));
			}

		},
		showCompleteRequestModal() {
			this.showCompletedModal = true;
		},
		showCancelRequestModal() {
			this.showCancelModal = true;
		},

		onSaveContravention() {
			this.Save();
		},

		Save() {
			if (this.contravention instanceof Contravention) {
				this.saving = true;
				let go = true;

				let obj = {
					id: this.contravention.id,
					lcrId: this.contravention.lcrId,
					officerId: this.contravention.officerId,
					typeId: this.contravention.typeId.getRawValue(),
					comments: this.contravention.comments.getRawValue(),
					attachment: []
				};

				let x = 0;
				if (this.contravention.attachment) {
					for (x = 0; x < this.contravention.attachment.length; x++) {
						obj.attachment.push({
							id: this.contravention.attachment[x].id,
							comments: this.contravention.attachment[x].comments.value
						});
					}
				}
				if (go) {
					Vue.prototype.$http({
						method: 'put',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/contravention/${this.contravention.id}?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						data: obj
					}).then(resp => {
						// Handle Success
						this.contravention.id = resp.data.id;
						this.submitted = 1;
						this.saveState = 'success';
						this.submissionStatus = 'submission-success';
						this.$refs.refAttachments.autoSave();
						this.saving = false;
						this.SaveSuccess();
						// this.onSubmitPromiseDeferred.resolve();
					}).catch(error => {
						this.saving = false;
						this.saveState = 'fail';
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						} else {
							// ErrorHandler.RedirectToLogin();
						}
						// this.onSubmitPromiseDeferred.reject();
					}).finally(() => {
						this.saving = false;
						this.isButtonDisabled = false;
					});
				}
			}
		},


		SaveSuccess() {
			// TODO: Show thank you message?
			this.submitted = 1;
			this.saveSuccess = 2;
			this.laneClosureRequest.saveChanges();
			this.$router.push({ name: "LaneClosureRequestContraventions", params: { id: this.laneClosureRequest.id } });
		},


		sendNewMessage(obj) {
			if (obj.message != null && obj.message != "") {
				this.sendingMessage = true;
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/contravention/${this.contravention.id}/new-message?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
				}).then(resp => {
					this.contravention.message = [];
					let x = 0;
					for (x = 0; x < resp.data.length; x++) {
						this.contravention.message.push(new LaneClosureRequestMessage(resp.data[x]));
					}
					this.sendingMessage = false;

					this.PostNewMessageSuccess();
				}).catch(error => {
					this.sendingMessage = false;

					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});


			}
		},
		PostNewMessageSuccess() {},


		zoomAllBlocks() {
			this.$store.dispatch("map/zoomAllBlocks", null);
		},
		zoomToBlockId(id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			if (this.laneClosureRequest.block) {
				let x = 0;
				let z = 0;
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].mapPolyline && this.laneClosureRequest.block[x].blockId == id) {
						let polyBounds = this.laneClosureRequest.block[x].mapPolyline.getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}
						setBounds = true;
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},

		setBlockPolyline(block) {
			let that = this;
			let foundIndex = null;
			let blockPolyline = null;
			if (block) {
				// find the existing marker/placemark.
				if (this.laneClosureRequest.block) {
					for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
						if (this.laneClosureRequest.block[x].blockId == block.blockId) {
							foundIndex = x;
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											blockPolyline = that.$store.getters["map/polylines"][x];
										}
									}
								}
							}
						}
					}
				}
				if (foundIndex == null || blockPolyline == null) {
					// add the block to the map.
					// look for existing block in lane closure request, and select it.
					var myParser = new Vue.prototype.$geoXML3.parser({
						map: null,
						afterParse: function(doc) {
							let xx = 0;
							var coords = [];
							let zz = 0;
							for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
								for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
									coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
								}
							}
							let mapPolyline = new google.maps.Polyline({
								map: that.$store.state.map.map,
								path: coords,
								strokeColor: '#666666',
								strokeOpacity: 1.0,
								strokeWeight: 8
							});
							mapPolyline.blockData = block;
							let mapIndex = -1;
							if (foundIndex == null) {
								let newBlock = new LaneClosureRequestBlock(block);
								that.laneClosureRequest.block.push(newBlock);
								foundIndex = that.laneClosureRequest.block.length - 1;
							}
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
											mapIndex = x;
										}
									}
								}
							}
							if (mapIndex == -1) {
								// not found, so add the polyline.
								that.$store.commit("map/addPolyline", mapPolyline);
							}
							google.maps.event.addListener(mapPolyline, 'click', function() {
								that.$bus.$emit('view-lcr:map:block-edit', this.blockData.blockId);
							});
							return;
						}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						if (block.streetName != that.laneClosureRequest.affectedStreet.value) {
							// turning restriction
							color = "7f000000"
						}
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				}
			}
		},

		showOnMap() {
			Vue.prototype.$bus.$emit("map:toggle", null, 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
				this.setAllPolylineColours();
			});
		},

		setAllPolylineColours() {
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
					}
				}
			}
		},

		onMapBlockEdit: function(id) {
			if (typeof this.$refs.blockDetails != "undefined") {
				this.$refs.blockDetails.selectBlockById(id);
			}
		},
		onMapBlockClick: function(evt) {
			if (evt.blockData) {
				// we clicked a block!
				//
				// check if we have the block defined
				let x = 0;
				let found = false;
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == evt.blockData.blockId) {
						found = true;
					}
				}
				if (!found) {
					// let's add it back in
					evt.setMap(null);
					this.setBlockPolyline(evt.blockData);
				} else {
					if (typeof this.$refs.blockDetails != "undefined") {
						this.$refs.blockDetails.editBlockById(evt.blockData.blockId);
					}
				}
			}
		},


		getLaneText(laneId) {
			if (laneId) {
				return Format.searchByGroupedId(laneId, LaneClosureRequest.getLaneAffectedOptions).name;
			}
			return null;
		},

		getParkingLaneRemovedText(laneId) {
			if (laneId) {
				return Format.searchById(laneId, LaneClosureRequest.getParkingLaneOptions).name;
			}
			return null;
		},

		getTransitText(transitId) {
			if (transitId !== null) {
				var transit = Format.searchById(transitId, LaneClosureRequest.getAffectTransitOptions);
				if (transit) {
					return transit.name;
				}
			}
			return null;
		},

		getParkingRemovalText(parkingRemovalId) {
			if (parkingRemovalId !== null) {
				return Format.searchById(parkingRemovalId, LaneClosureRequest.getViewParkingRemoveOptions).name;
			}
			return null;
		},
		getWorkDoneForText(workId) {
			if (workId) {
				let org = Format.searchById(workId, LaneClosureRequest.getMajorUtilitiesOptions);
				if (org) {
					return org.name;
				} else {
					org = Format.searchById(workId, LaneClosureRequest.getThirdPartiesOptions);
					if (org) {
						return org.name;
					}
				}
			}
			return null;
		},



		getRestrictionTypeText(restrictionTypeId) {
			if (restrictionTypeId) {
				return Format.searchById(restrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).name;
			}
			return null;
		},

		getLeftTurnSignalText(turn) {
			if (turn !== null) {
				return Format.searchById(turn, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getYesNoText(val) {
			if (val !== null) {
				return Format.searchById(val, LaneClosureRequest.getYesNoOptions).name;
			}
			return null;
		},

		getSidewalkText(sidewalkId) {
			if (sidewalkId) {
				return Format.searchById(sidewalkId, LaneClosureRequest.getSidewalkOptions).name;
			}
			return "N/A";
		},

		getDczRequiredText(dcz) {
			if (dcz) {
				return Format.searchById(dcz, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getBicycleText(bicycleId) {
			if (bicycleId) {
				return Format.searchById(bicycleId, LaneClosureRequest.getAffectBicycleOptions).name;
			}
			return "N/A";
		},


		emailHref(value) {
			return "mailto:" + value;
		},

		onBackToDetails() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			}
		},

		onBackToContraventions() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "LaneClosureRequestContraventions", params: { id: this.laneClosureRequest.id } });
			}
		},

		// required fields notifying modal
		modalRequiredFieldClose() {
			this.showRequiredFieldModal = false;
		},

		showErrors(errors) {
			this.submissionStatus = 'submission-error';
			this.modalRequiredFieldList = [];
			for (let field in errors) {
				this.modalRequiredFieldList.push(errors[field]);
			}
			this.showRequiredFieldModal = true;
		},

		onOfficerSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/officers?q=' + encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		// Addeds a transaction line with contact attached.
		onOfficerSelect(selected) {
			this.contravention.officerId = parseInt(selected.userId);
			this.contravention.officer = selected;
			this.$refs.searchOfficer.value = "";
		},

		Load(id = this.id, contraventionId = this.contraventionId) {
			this.loaded = false;
			// Remove any messages being displayed.
			this.submissionStatus = null;
			if (id && Format.TryParseInt(id) > 0 && contraventionId && Format.TryParseInt(contraventionId) > 0) {
				this.Get(id, contraventionId);
			}
		},
		// Loads lane closure request into the component based on provided id.
		Get(id, contraventionId) {
			if (Format.TryParseInt(id) && Format.TryParseInt(contraventionId)) {
				this.loaded = false;
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/contravention/${contraventionId}?r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					this.laneClosureRequest = new LaneClosureRequest(response.data.request);
					this.downloadToken = response.data.downloadToken;
					this.downloadTokenExpires = response.data.downloadTokenExpires;

					this.contravention = new Contravention(response.data.contravention);
					// this.contravention.lcrId = id;
					// this.contravention.typeId.value = 2;

					this.loaded = true;
					if (this.laneClosureRequest.block) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							this.setBlockPolyline(this.laneClosureRequest.block[x]);
						}
						this.zoomAllBlocks();
					}
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response && error.response.data) {
							this.loaded = false;
							this.transactionStatus = 'load-error';
							this.errorDetails = error.response.data;
						}
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				});
			}
		},
	},
	beforeRouteEnter(to, from, next) {
		if (store.getters.userHasRole('internal_admin_requests') || store.getters.userHasRole('system_admin') || store.getters.userHasRole('internal_admin_reports')
					|| store.getters.userHasRole('officer_requests') || store.getters.userHasRole('officer_reports')
		) {
			next(vm => {
				Vue.prototype.$bus.$emit("map:clear", 1);
				// Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
				if (this) {
					vm.Load(this.$route.params.id);
				}
			});
		}
		else {
			next({name: 'LaneClosureRequestContraventions', params:{id: to.params.id}});
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.$refs.refAttachments) {
			this.$refs.refAttachments.autoSave();
		}
		if (this.loaded && this.laneClosureRequest.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				Vue.prototype.$bus.$emit("map:clear", 1);
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						Vue.prototype.$bus.$emit("map:clear", 1);
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					Vue.prototype.$bus.$emit("map:clear", 1);
					next(true);
				}).bind(this);
				next(false);
			}
		} else {
			Vue.prototype.$bus.$emit("map:clear", 1);
			next(true);
		}
	},
}
</script>
<i18n>
	{
	"en-CA": {
	}
	}
</i18n>